exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CampaignHome_content__1M-6m {\n  background-color: #f4f8f9;\n  -webkit-flex-grow: 1;\n          flex-grow: 1;\n  width: 100%; }\n  .CampaignHome_content__1M-6m .CampaignHome_title__1P6Q8 {\n    color: #044591;\n    margin: 0 10px 0 0; }\n  .CampaignHome_content__1M-6m .CampaignHome_paperCards__14XT5 {\n    padding: 15px; }\n    .CampaignHome_content__1M-6m .CampaignHome_paperCards__14XT5 .CampaignHome_cards__LbtXR {\n      margin: 10px; }\n", ""]);

// exports
exports.locals = {
	"content": "CampaignHome_content__1M-6m",
	"title": "CampaignHome_title__1P6Q8",
	"paperCards": "CampaignHome_paperCards__14XT5",
	"cards": "CampaignHome_cards__LbtXR"
};